import { useEffect } from "react";

/**
 * Requests a screen wake lock so the device doesn't dim/sleep during a round.
 * Re-acquires on visibilitychange (the OS releases it when the tab goes background).
 * Fails silently on browsers without the Wake Lock API (older Safari).
 */
export function useWakeLock(active = true) {
  useEffect(() => {
    if (!active) return;
    let wakeLock = null;
    let released = false;

    const acquire = async () => {
      if (released || !("wakeLock" in navigator)) return;
      try {
        wakeLock = await navigator.wakeLock.request("screen");
      } catch { /* permission denied or unsupported */ }
    };

    const onVisibility = () => {
      if (document.visibilityState === "visible" && !released && !wakeLock) acquire();
      if (document.visibilityState === "hidden") wakeLock = null;
    };

    acquire();
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      released = true;
      document.removeEventListener("visibilitychange", onVisibility);
      if (wakeLock) wakeLock.release().catch(() => {});
    };
  }, [active]);
}
